import { ThemeOptions } from '@mui/material';

import { tokens } from '../../theme/generated/tokens';
import { cssVars } from '../../utils/cssVars';

const vars = cssVars(
  {
    color: undefined,
    background: undefined,
    size: undefined,
    fontSize: undefined,
  },
  'ds-avatar'
);

export const avatarTheme: ThemeOptions['components'] = {
  DsAvatar: {
    defaultProps: {
      variant: 'circular',
      size: 'md',
      color: 'aqua',
    },
    styleOverrides: {
      root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'uppercase',
        fontWeight: '600',
        fontFamily: 'Poppins',
        background: vars.refs.background,
        fontSize: vars.refs.fontSize,
        lineHeight: vars.refs.fontSize,
        color: vars.refs.color,
        minHeight: vars.refs.size,
        height: vars.refs.size,
        maxHeight: vars.refs.size,
        minWidth: vars.refs.size,
        width: vars.refs.size,
        maxWidth: vars.refs.size,
      },
      circularBlue: vars.setValues({
        color: tokens.theme.fg.categorical.onBlueSubtle,
        background: tokens.theme.bg.categorical.blueSubtle,
      }),
      circularGreen: vars.setValues({
        color: tokens.theme.fg.categorical.onGreenSubtle,
        background: tokens.theme.bg.categorical.greenSubtle,
      }),
      circularIndigo: vars.setValues({
        color: tokens.theme.fg.categorical.onIndigoSubtle,
        background: tokens.theme.bg.categorical.indigoSubtle,
      }),
      circularAqua: vars.setValues({
        color: tokens.theme.fg.categorical.onAquaSubtle,
        background: tokens.theme.bg.categorical.aquaSubtle,
      }),
      circularYellow: vars.setValues({
        color: tokens.theme.fg.categorical.onYellowSubtle,
        background: tokens.theme.bg.categorical.yellowSubtle,
      }),
      circularRed: vars.setValues({
        color: tokens.theme.fg.categorical.onRedSubtle,
        background: tokens.theme.bg.categorical.redSubtle,
      }),
      squareIndigo: vars.setValues({
        color: tokens.theme.fg.categorical.onIndigoStrong,
        background: tokens.theme.bg.categorical.indigoStrong,
      }),
      squareAqua: vars.setValues({
        color: tokens.theme.fg.categorical.onAquaStrong,
        background: tokens.theme.bg.categorical.aquaStrong,
      }),
      squareYellow: vars.setValues({
        color: tokens.theme.fg.categorical.onYellowStrong,
        background: tokens.theme.bg.categorical.yellowStrong,
      }),
      squareGrey: vars.setValues({
        color: tokens.theme.fg.categorical.onGreyStrong,
        background: tokens.theme.bg.categorical.greyStrong,
      }),
      squareBlue: vars.setValues({
        color: tokens.theme.fg.categorical.onBlueStrong,
        background: tokens.theme.bg.categorical.blueStrong,
      }),
      squareGreen: vars.setValues({
        color: tokens.theme.fg.categorical.onGreenStrong,
        background: tokens.theme.bg.categorical.greenStrong,
      }),

      circular: {
        borderRadius: tokens.theme.radius.full,
        border: `1px solid ${vars.refs.background}`,
      },
      square: {
        borderRadius: tokens.theme.radius.sm,
      },
      '2xl': vars.setValues({ size: '100px', fontSize: '40px' }),
      xl: vars.setValues({ size: '48px', fontSize: '20px' }),
      lg: vars.setValues({ size: '40px', fontSize: '16px' }),
      md: vars.setValues({ size: '32px', fontSize: '14px' }),
      sm: vars.setValues({ size: '28px', fontSize: '12px' }),
      xs: vars.setValues({ size: '24px', fontSize: '10px' }),
      '2xs': vars.setValues({ size: '20px', fontSize: '6px' }),
      disabled: {
        color: tokens.theme.disabled.fg,
        background: tokens.theme.disabled.bg,
        borderColor: tokens.theme.disabled.bg,
      },
    },
  },
};
